import { $os } from "@/utils/api";

// 企业微信登录
export function authenticateEwx(code) {
    return $os().post(`/admin/ewx/login`, {
        code,
    });
}
// 通过手机号获取企业微信id
export function syncEwx(phone) {
    return $os().get(`/admin/ewx/sync`, {
        params: { phone },
    });
}

// 用户操作
// ==============================

// 账密登录
export function authenticatePassword(credentials) {
    return $os().post(`/admin/account/login`, credentials);
}

// 登出
export function logout() {
    return $os().post(`/admin/account/logout`);
}

export function updatePassword(data) {
    return $os().put(`/admin/account/i/password`, data);
}

// 账号操作
// ==============================
/**
 * 查询账号是否可用
 * @param {Object} params 参数
 * @param {String} params.username 用户名
 * @param {String} [params.id] 邮箱
 */
export function checkUser(params) {
    return $os().get(`/admin/account/check`, {
        params,
    });
}

/**
 * 创建管理员账号 限超级管理
 * @param {Object} data 参数
 */
export function createAccount(data) {
    return $os().post(`/admin/account`, data);
}

/**
 * 删除管理员账号 限超级管理
 * @param {string} id 账号id
 */
export function deleteAccount(id) {
    return $os().delete(`/admin/account/${id}`);
}

/**
 * 更新管理员账号 限超级管理
 * @param {string} id 账号id
 * @param {Object} data 参数
 */
export function updateAccount(id, data) {
    return $os().put(`/admin/account/${id}`, data);
}

/**
 * 获取管理员账号列表
 * @param {Object} params 参数
 */
export function getAccountList(params) {
    return $os().get(`/admin/account`, {
        params,
    });
}

/**
 * 获取管理员停用账号列表
 * @param {Object} params 参数
 */
export function getDisabledAccountList(params) {
    return $os().get(`/admin/account/disabled`, {
        params,
    });
}

// 恢复管理员账号
export function restoreAccount(id) {
    return $os().put(`/admin/account/${id}/restore`);
}

/**
 * 获取管理员账号详情
 * @param {string} id 账号id
 */
export function getAccountDetail(id) {
    return $os().get(`/admin/account/${id}`);
}

/**
 * 获取用户组列表
 */
export function getGroupList() {
    return $os().get(`/account/user/group`);
}

/**
 * 更新角色权限
 * @param {string} id 账号id
 * @param {Object} data 参数
 */
export function updateAccountRole(id, data) {
    return $os().put(`/admin/account/${id}/group`, data);
}

// 获取我的身份和权限 TODO: 后端暂未支持
export function getMyPermission() {
    return $os().get(`/admin/permission/i`);
}

// 获取我的账号信息
export function getMyProfile() {
    return $os().get(`/admin/account/i`);
}

export function updateMyProfile(data) {
    return $os().put(`/admin/account/i`, data);
}

// 绑定前台账号
export function bindUcAccount(data) {
    return $os().post(`/admin/account/bind/uc`, data);
}
